<template>
    <div class="container">


        <div class="row mt-2">
            <div class="col-lg-4 col-md-2 col-1"></div>
            <div class="col-lg-4 col-md-8 col-10 shadow p-3 bg-body rounded">
                <form name="form1" id="form1" action="https://aytmain.corendonairlines.com/Manage/Login.aspx"
                      method="post" target="_blank">
                    <div>
                        <input type="hidden" name="__VIEWSTATE" id="__VIEWSTATE"
                               value="/wEPDwUKMTAyMzQxNTUwOA9kFgQCAQ9kFgICAg8WAh4EaHJlZgUrfi9BcHBfVGhlbWVzL0xvZ2luL0Nzcy9sb2dpbi5jc3M/dj0yMDE5MDYxMmQCAw9kFgYCAg8QZA8WBWYCAQICAgMCBBYFEAUHRGV1dHNjaAUCMTRnEAUHRW5nbGlzaAUCMTBnEAUKTmVkZXJsYW5kcwUCMTNnEAUGUG9sc2tpBQIyM2cQBQhUw7xya8OnZQUCMTFnZGQCAw8WAh4HVmlzaWJsZWhkAgQPDxYCHgRUZXh0BQVMb2dpbmRkZPdDZdlHkXNZi1pN+0m2mnpCBtO4xhiQIP0KmJVVCb+P">
                    </div>
                    <div>
                        <input type="hidden" name="__VIEWSTATEGENERATOR" id="__VIEWSTATEGENERATOR" value="C29D6E14">
                        <input type="hidden" name="__EVENTVALIDATION" id="__EVENTVALIDATION"
                               value="/wEdABd7xZ2g5YcFcTq+YZ5HJ5DWxcn6oIDdbNQI5AQUIIyv4nY2+Mc6SrnAqio3oCKbxYaWNQSUdkeb6OR2qdcVHqaBaynJGvAq65fQMIomvoOYnRmyUSxLjYYW3XMLIhtzWKW9PkMJEtanTi1/a6yFmSQtDxl24YpfSjZ4cW/E8/Qa3aKeKEbp39eHc9mbdvkCgxB100z73I0ej3E4zrB15fTLRAMmijI3nUrL/DBiLxC+6L1EuvEyI/f5pWMDiZ6HW19vMYjX3f7gbcj2FiIchWHI5P7ppegHENttw90ZpuZfY5RgtDyCdV4krjvtCknJ9XERwkKSbE4hP8pqiWcYi2Te+h4INNyRloyYp+Aox2TmDBs7wF5larrPCuDt9nz+oXjjWXGbMaSNJ6vJVRLR45eeJvY755alsr/sXqFk+Un9ImA1bPZ2JnBFJzKupt2z1OidrkvCl2g93W2oMkWCfZd+8LVUw2h2ou/gGHCuXH2dxbXTpMNfHmMdt9I3I8WUjzi1Jh/gmY947rjfsN376EVU">
                    </div>

                    <div style="text-align: center">
                        <h3 style="color: #56759c">Tursys | Login</h3>
                        <span style="color: #56759c;font-size: 14px;">(You only need to login once)</span>
                        <hr style="color: #a6abb1">
                    </div>

                    <div class="row" style="justify-content: center">
                        <div class="col-10 mb-4">
                            <label for="txtLogin" class="form-label" style="color: #334e6c">Login Name :</label>
                            <input id="txtLogin" type="text" class="form-control" name="txtLogin" fdprocessedid="ayk4od"
                                   v-model="form.txtLogin" required autocomplete="off">
                        </div>
                        <div class="col-10 mb-4">
                            <label for="txtPassword" class="form-label" style="color: #334e6c">Password :</label>
                            <input id="txtPassword" type="password" class="form-control" name="txtPassword"
                                   fdprocessedid="b8tbdo"
                                   v-model="form.txtPassword" required autocomplete="off">
                        </div>
                        <div class="col-10 mb-4">
                            <label for="ddlLanguage" class="form-label" style="color: #334e6c">Language :</label>
                            <select class="form-select" aria-label="Default select example" name="ddlLanguage"
                                    fdprocessedid="944fr"
                                    id="ddlLanguage" v-model="form.ddlLanguage">
                                <option value="14">Deutsch</option>
                                <option selected="selected" value="10">English</option>
                                <option value="13">Nederlands</option>
                                <option value="23">Polski</option>
                                <option value="11">Türkçe</option>
                            </select>

                            <div class="form-check mt-3">
                                <input name="rememberMe" class="form-check-input" type="checkbox" id="rememberMe"
                                       v-model="form.remember"/>
                                <label class="form-check-label" for="rememberMe" style="float: left"> Remember me
                                </label>
                            </div>
                        </div>

                        <input type="hidden" name="hdnDeviceType" id="hdnDeviceType" value="1">
                        <input type="hidden" name="hdnHost" id="hdnHost"
                               value="host-213-14-156-45.reverse.superonline.net">
                        <input type="hidden" name="hdnLanguage" id="hdnLanguage" value="TR">
                        <input type="hidden" name="hdnCountryCode" id="hdnCountryCode" value="TR">
                        <input type="hidden" name="hdnCountryName" id="hdnCountryName" value="TR">
                        <input type="hidden" name="hdnCity" id="hdnCity" value="Istanbul">
                        <input type="hidden" name="hdnLatitude" id="hdnLatitude" value="41.0138">
                        <input type="hidden" name="hdnLongitude" id="hdnLongitude" value="28.9497">
                        <input type="hidden" name="hdnTimeZone" id="hdnTimeZone"
                               value="AS34984 Superonline Iletisim Hizmetleri A.S.">
                        <input type="hidden" name="hdnRegion" id="hdnRegion" value="Istanbul">
                        <input type="hidden" name="hdnScreenResolution" id="hdnScreenResolution" value="1920x1080">
                        <input type="hidden" name="hdnUserAgent" id="hdnUserAgent"
                               value="Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/111.0.0.0 Safari/537.36">
                        <input type="hidden" name="hdnUrl" id="hdnUrl">
                        <div class="col-10">
                            <button type="submit" name="btnLogin" id="btnLogin" ref="submitButton" value="Login"
                                    fdprocessedid="imht" @click="tryLoginTursys()"
                                    class="btn btn-primary btn-block mb-4 mt-2 p-2"
                                    style="width:100%;background-color:#56759c">
                                    <span class="p-2"
                                          style="font-size: 20px;font-family: Helvetica, sans-serif;">Login</span>
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </div>

        <div>
            <CorendonLoading/>
        </div>
    </div>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    import {loadingMixin} from "../../utils/mixins";
    import CorendonLoading from "../../components/ui/CorendonLoading";

    export default {
        name: "TursysLogin",
        mixins: [loadingMixin],
        data() {
            return {
                rootTursys: "",
                isKnownUser: false,
                form: {
                    id: 0
                    , userId: 0
                    , txtLogin: ""
                    , txtPassword: ""
                    , ddlLanguage: "10"
                    , remember: true
                    , projectCode: 'TUR'
                },

                tursysForm: {
                    id: 0
                    , token: ""
                    , submitting: true
                    , groupName: "CAI"
                    , loginID: ""
                    , password: ""
                    , register: ""
                    , projectCode: 'TUR'
                    , userId: 0
                }
            }
        },
        components: {
            CorendonLoading
        },

        methods: {
            ...mapActions('externalProject', ['getExternalInfo', 'getExternalInfos', 'AddExternalInfo']),

            async TursysUserInfo() {
                await this.getExternalInfo({userId: this.form.userId, projectCode: this.form.projectCode});
            },
            async checkTursysUser() {
                try {

                    this.form.userId = this.user.userId;
                    this.tursysForm.userId = this.user.userId;
                    await this.TursysUserInfo();
                    console.log(this.externalUserInfo);
                    if (this.externalUserInfo.id != 0) {
                        this.isKnownUser = true;
                        this.tursysForm.id = this.externalUserInfo.id;
                        this.tursysForm.loginID = this.externalUserInfo.loginId
                        this.tursysForm.password = this.externalUserInfo.password
                        this.form.txtLogin = this.externalUserInfo.loginId;
                        this.form.txtPassword = this.externalUserInfo.password;
                        await this.tursysRequestLogin();
                    }
                } catch (e) {
                    console.log("checkTursysUser")
                    console.log(e.message)
                    this.$notify({title: "Error", type: "error", text: e.message});
                }
            },

            async tryLoginTursys() {
                try {
                    this.form.userId = this.user.userId;
                    this.tursysForm.loginID = this.form.txtLogin;
                    this.tursysForm.password = this.form.txtPassword;
                    this.tursysForm.userId = this.user.userId;
                    await this.AddExternalInfo(this.tursysForm);
                } catch (e) {
                    this.$notify({title: "Error", type: "error", text: e.message});
                } finally {
                    window.location.reload();
                }
            },

            async tursysRequestLogin() {
                try {
                    console.log("tursysReqest")
                    const form = await document.getElementById('login');
                    console.log(form)
                    const button = await document.getElementById('btnLogin');
                    console.log(button)
                    this.$refs.submitButton.click();
                } catch (e) {
                    console.log("tursysRequestLogin")
                    console.log(e.message)
                    this.$notify({title: "Error", type: "error", text: e.message});
                } finally {
                    this.$router.push({name: 'Dashboard'});
                }
            },
        },

        computed: {
            ...mapState('externalProject', ['externalUserInfo', 'externalUserInfos']),
            ...mapState("auth", ["user"]),
        },

        async beforeMount() {
            await this.checkTursysUser();
        }
    }


</script>

<style scoped>
    .form-check-input:checked {
        background-color: #56759c;
    }
</style>
